// frontend/src/components/member-dashboard/components/SideMenu.js
import React from "react";
import PropTypes from "prop-types";
import MembershipSidebar from "./MembershipSidebar";
import MemberAddOns from "../../MemberAddOns";
import "./SideMenu.css";

// Import icons
import {
  FaCalendarAlt,
  FaChartLine,
  FaUser,
  FaSpa,
} from "react-icons/fa";

/**
 * SideMenu component for member dashboard navigation
 * @param {Object} props - Component props
 * @param {Function} props.onSelect - Function to call when a menu item is selected
 * @param {string} props.currentView - Currently selected dashboard view
 * @param {Object} props.profile - User profile object
 * @param {Object} props.selectedSession - The currently selected session
 * @param {Function} props.onAddOnUsed - Callback for when an add-on is used
 * @returns {JSX.Element} - Rendered component
 */
const SideMenu = ({
  onSelect,
  currentView,
  profile,
  selectedSession,
  onAddOnUsed,
}) => {
  return (
    <nav className="side-menu">
      <div className="menu-header">
        <h3>Member Dashboard</h3>
      </div>
      <div className="menu-content">
        <ul className="menu-items">
          <li className={currentView === "calendar" ? "active" : ""}>
            <button
              type="button"
              className="menu-link"
              onClick={() => onSelect("calendar")}
            >
              <FaCalendarAlt className="menu-icon" />
              <span>My Sessions</span>
            </button>
          </li>
          <li className={currentView === "booking" ? "active" : ""}>
            <button
              type="button"
              className="menu-link"
              onClick={() => onSelect("booking")}
            >
              <FaSpa className="menu-icon" />
              <span>Book A Session</span>
            </button>
          </li>
          <li className={currentView === "activity" ? "active" : ""}>
            <button
              type="button"
              className="menu-link"
              onClick={() => onSelect("activity")}
            >
              <FaChartLine className="menu-icon" />
              <span>Activity</span>
            </button>
          </li>
          <li className={currentView === "profile" ? "active" : ""}>
            <button
              type="button"
              className="menu-link"
              onClick={() => onSelect("profile")}
            >
              <FaUser className="menu-icon" />
              <span>Profile</span>
            </button>
          </li>
        </ul>

        {/* Membership Sidebar */}
        <MembershipSidebar profile={profile} />

        {/* Add-ons Section */}
        <div className="add-ons-sidebar">
          <MemberAddOns
            bookingId={selectedSession ? selectedSession._id : null}
            onAddOnUsed={onAddOnUsed}
          />
        </div>
      </div>
    </nav>
  );
};

SideMenu.propTypes = {
  onSelect: PropTypes.func.isRequired,
  currentView: PropTypes.string.isRequired,
  profile: PropTypes.object,
  selectedSession: PropTypes.object,
  onAddOnUsed: PropTypes.func,
};

export default SideMenu;
